<template>
    <div v-show="isShow" :style="domStyle">
        <!-- 请在此添加代码 -->
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
import Vue from 'vue';
import { locale, Page } from 'view-design';
import cn from 'view-design/dist/locale/zh-CN';
import en from 'view-design/dist/locale/en-US';
import dragResize from "../../system/dragResize";//页面路径
export default {
    name : "fvPreventAsthmaCurve",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.oldTime="";
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },

    data : function(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            updataOk :true,
            dataList:[]
        }
    },
    mounted : function(){
        // this.getInitData();
        this.initOption();
       
    },
    methods : {
        //获取x轴坐标数据
        async getInitData(){
            this.dataList = [];
            var min = parseInt(await this.executionScript(AsyncFunction("return " + this.minX)));
            var max = parseInt(await this.executionScript(AsyncFunction("return " + this.maxX)));
            this.yAxisMin = await this.executionScript(AsyncFunction("return " + this.minY));
            this.yAxisMax = await this.executionScript(AsyncFunction("return " + this.maxY));
            for(min;min<max;min++){
                this.dataList.push(min)
            }
            this.xAxisMin = await this.executionScript(AsyncFunction("return " + this.minX));
            this.xAxisMax = await this.executionScript(AsyncFunction("return " + this.maxX));
            
            // var min =0;
            // var max = 100;
            // this.yAxisMin = 0;
            // this.yAxisMax = 100;
            // for(min;min<max;min++){
            //     this.dataList.push(min)
            // }
        },
        //初始化脚本
        initScript(value){
            var value = value.replace(/\$/g,'__dbTags.$');
            var value = value.replace(/\\/g, ".$");
            return value;
        },
        /**
         * 作用：初始化曲线
         */
        initOption(){
            if(this.transparent){
                var backColor = "rgba(128, 128, 128,0)";
            }else{
                var backColor = this.backColor;
            }
            this.triggerOn = this.infoType == 1 || this.infoType == undefined ? "mousemove" : "click";
       
            this.option = {
                backgroundColor: backColor,//设置背景色 curveBackgroundColor
                title: {
                    text: this.title.name,
                    left: this.title.align,
                    textStyle:{
                        fontSize:this.titleFontSize,
                        color:this.fontColor,//标题颜色
                    },
                    zlevel: 1000
                },
                tooltip: {
                    show: this.hasLegend,
                    trigger: 'item',
                    triggerOn: this.triggerOn,//mousemove|click
                    formatter: '{a} <br/>{b} : {c}'
                },
                color:[],
                legend: {
                    type: 'scroll',
                    show: this.Legend,//是否显示图例
                    data:[],
                    textStyle: {
                        fontSize: 14
                    },
                    width :"100%",
                    
                    top:25,
                    selected: {},
                },
                xAxis: {
                    type: 'value',
                    name: this.xAxisName,
                    splitLine: {
                        show: this.curveGraid ? this.curveGraid:true
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: this.curveAxisColor ? this.curveAxisColor: "#000",  //更改坐标轴文字颜色
                        fontSize : 14      //更改坐标轴文字大小
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color:this.curveAxisColor ? this.curveAxisColor: "#000",//设置x轴的颜色
                        }
                    },
                    // data: this.dataList.map(function (item) {
                    //     return item;
                    // }),
                    axisTick: {
                        alignWithLabel: true,
                    },
                    max: this.xAxisMax,
                    min: this.xAxisMin,
                    splitNumber : 8,
                    // axisLine: {//箭头
                    //     symbol: ['none', 'arrow']
                    // }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: {
                    name: this.yAxisName,
                    type: 'value',
                    show: true,//this.yAxisShow
                    // boundaryGap: [0, '100%'],
                    axisLabel: {
                        show: true,
                            textStyle: {
                            color:  this.curveAxisColor ? this.curveAxisColor: "#000", //更改坐标轴文字颜色
                            fontSize : 14      //更改坐标轴文字大小
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.curveAxisColor ? this.curveAxisColor: "#000",//设置x轴的颜色
                        }
                    },
                    splitLine: {
                        show: true
                    },
                    min:this.yAxisMin,
                    max:this.yAxisMax,
                },
                series: []
            };
            this.option.legend.data = [];
            for(var i=0;i<this.store.length;i++){
                this.option.legend.data.push({
                    name:this.store[i].name,
                    textStyle:{color:this.store[i].color}
                })
            }
            this.chart = document.createElement("div");
            this.chart.style.position = "absolute";
            this.$el.title="";
            this.$el.appendChild(this.chart);
            this.curve = this.$echarts.init(this.chart);
            this.curve.setOption(this.option,true);
            this.curve.cycle = 0;
            this.curve.resize();
            var now = new Date();
            this.tempDataTime = now.getTime();
        },
        /*数据刷新*/
        async updata(){
            this.option.series=[];
            for(var i=0;i<this.store.length;i++){
                var data =[];
                for(var o=0;o<this.store[i].data.length;o++){
                    var arr =[await this.executionScript(AsyncFunction("return " + this.initScript(this.store[i].data[o].x))),await this.executionScript(AsyncFunction("return " + this.initScript(this.store[i].data[o].y)))]
                    data.push(arr)
                }
                //动态设置坐标轴
                this.option.series.push({
                    name: this.store[i].name,
                    type: 'line',
                    data: data,
                    markPoint: {//工作点
                        symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAALhJREFUaEPtmDEOgzAQBNcN/CJFKuD/b0moUuQX0IAsUTk01h4uwrhEsIfHw8k46YIxP7qXpLGIfg/fdYoul6IDcx4TqKDKCpzBQiEUqiCAQiYsuhAKoZBJAIVMgHQhFEIhkwAKmQDT8fNhxvw8/pTUF1cXSZ/oQnkCW3Royzwm0JL2Wa2/WIF8ihY92n3E0W/OyVwlUXajbCUqlSlvRyEUQiGTAAqZAOlCKIRCJgEUMgHShVDo7grtYrbhwejcT3gAAAAASUVORK5CYII=',
                        label: {//label样式
                            show: true,
                            align: "left",
                            fontSize: 15 ,
                            position: 'top',
                            backgroundColor: "#000",
                            borderRadius: [8, 8, 8, 0],
                            padding: [5, 5, 5, 5],
                            offset:[2,5]
                        },
                        itemStyle: {//
                            color: 'red',
                            borderColor: '#34aaff',
                            borderWidth: 4,
                            opacity: 1
                        },
                        symbolSize:10,//图片缩放比例
                        data: [//工作点数据xy坐标
                            // {
                            //     value: "0.00 ,9.33",
                            //     coord: [6,9]
                            // }
                        ],
                        tooltip:{//鼠标悬浮样式
                            show:false
                        }
                    },
                });
                this.option.color.push(this.store[i].color);
            }
            var data = {
                value: await this.executionScript(AsyncFunction("return " + this.initScript(this.operatingPointX)))+"   "+await this.executionScript(AsyncFunction("return " + this.initScript(this.operatingPointX))),
                coord:[await this.executionScript(AsyncFunction("return " + this.initScript(this.operatingPointX))),await this.executionScript(AsyncFunction("return " + this.initScript(this.operatingPointX)))]
            }
            //重绘工作点
            this.option.series[0].markPoint.data = [data];

            //绘制xy坐标轴
            if(this.updataOk){
                this.dataList = [];
                var min = this.decimalPlaces(await this.executionScript(AsyncFunction("return " + this.initScript(this.minX))),2);
                var max = this.decimalPlaces(await this.executionScript(AsyncFunction("return " + this.initScript(this.maxX))),2);
                
                for(min;min<max;min++){
                    this.dataList.push(min)
                }
                this.option.xAxis.data = this.dataList;
                
                this.option.yAxis.min = this.decimalPlaces(await this.executionScript(AsyncFunction("return " + this.initScript(this.minY))),2);
              
                this.option.yAxis.max = this.decimalPlaces(await this.executionScript(AsyncFunction("return " + this.initScript(this.maxY))),2);
                
                this.option.xAxis.min = this.decimalPlaces(await this.executionScript(AsyncFunction("return " + this.initScript(this.minX))),2);
                this.option.xAxis.max = this.decimalPlaces(await this.executionScript(AsyncFunction("return " + this.initScript(this.maxX))),2);

                this.updataOk = false;
                if(typeof(this.option.xAxis.max) === "number" && isNaN(this.option.xAxis.max)) {
                    this.updataOk = true;   
                }
            }
           
            this.curve.setOption(this.option,false);
        },
        async executionScript(script,param,registerName){
            if(param){
                if(typeof script == "string"){
                    var params = [];
                    var values = [];
                    for(var i = 0;i < param.length;i++){
                        params.push(param[i].paramName);
                        params.push(param[i].value);
                    }
                    return await AsyncFunction(...params,script).call(this,...values);
                }else if(typeof script == "function"){
                    return await script.call(this,...param);
                }else{
                    console.warn("脚本类型错误：" + typeof script + " 只允许字符创脚本和可执行函数脚本");
                    return;
                }
            }else{
                if(typeof script == "string"){
                    if(registerName){
                        if(this[registerName]){
                            return await AsyncFunction(script).call(this);
                        }
                    }else{
                        return await AsyncFunction(script).call(this);
                    }
                }else if(typeof script == "function"){
                    return await script.call(this);
                }else{
                    console.warn("脚本类型错误：" + typeof script + " 只允许字符创脚本和可执行函数脚本");
                    return;
                }
            }
        },
        /*
        *作用：保留小数位
        *参数1：值，参数2：保留几位小数
        */
        decimalPlaces(value,number){
            var paramsValue = Math.floor(parseFloat(value)* Math.pow(10,number)) / Math.pow(10,number);
            return paramsValue;
        },
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){

        },
        /*
            参数：无
            作用：系统周期调用
        */
       async onTimer(){
            
            if(this.isEnable) return;
            this.timeStep = 5;
            //实时刷新周期， 待使用
            var newTime= new Date().getTime();
            var time_sec = parseInt(Math.floor(newTime/1000));
            var dataTime = parseInt(Math.floor(this.tempDataTime/1000));
            if(time_sec>dataTime&&(time_sec-dataTime)%this.timeStep==0&&time_sec!=this.oldTime){
                this.oldTime=time_sec;
            }
            this.updata();
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        async reDraw(scaleObj){
            this.$el.style.fontSize = parseInt((12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px"; 
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.chart.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.chart.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom))+ "px";
            this.curve.resize();
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvPreventAsthmaCurve/fvPreventAsthmaCurve.vue